const messages = {
  createSubscriptionAnalyticsError: 'create.subscription.analytics.error',
  getSubscriptionError: 'get.subscription.error',
};

export default {
  messages,
};
